<template>
  <div class="pa-10">
    <v-row>
      <v-col cols="9">
        <h2>Learner: {{ agent.name }}</h2>
      </v-col>
      <v-col cols="3">
        <v-select
          :items="selectItems"
          item-text="name"
          item-value="id"
          :label="selected"
          loader-height="4"
          @change="onCourseChange"
        ></v-select>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12">
        <v-card class="mx-auto card-body" style="height:380px">
          <v-card-text>
            <v-row dense>
              <v-col cols="12" class="title blue--text">Overview</v-col>
            </v-row>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-row no-gutters>
              <v-col cols="3" class="caption font-weight-light">
                <v-row>
                  <all-courses-overview :agent="agent" />
                </v-row>
              </v-col>
              <v-col cols="3" class="body-1 font-weight-light">
                <v-row>
                  <v-col cols="12"
                    ><v-row class="justify-center">Launches</v-row></v-col
                  >
                </v-row>
                <v-row class="justify-center">
                  <pie-chart
                    :styles="myStyles"
                    :chart-data="launchesData"
                    :options="launchesOptions"
                  />
                </v-row>
              </v-col>
              <v-col cols="3" class="body-1 font-weight-light">
                <v-row>
                  <v-col cols="12"
                    ><v-row class="justify-center">Interactions</v-row></v-col
                  >
                </v-row>
                <v-row class="justify-center">
                  <pie-chart
                    :styles="myStyles"
                    :chart-data="interactionData"
                    :options="interactionOptions"
                  />
                </v-row>
              </v-col>
              <v-col cols="3" class="body-1 font-weight-light">
                <v-row>
                  <v-col cols="12"
                    ><v-row class="justify-center">Scores</v-row></v-col
                  >
                </v-row>
                <v-row class="justify-center">
                  <pie-chart
                    :styles="myStyles"
                    :chart-data="scoreData"
                    :options="scoreOptions"
                  />
                </v-row>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="6">
        <v-card class="mx-auto card-body" style="height:380px">
          <v-card-text>
            <v-row dense>
              <v-col cols="12" class="title blue--text"
                >Time Spent Leaderboard</v-col
              >
            </v-row>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <leader-board
              :agentCoursesData="agent.courses"
              :agent="agent.id"
              :agentName="agent.name"
              :tabSelected="timeTab"
              class="ml-2"
            />
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col cols="6">
        <v-card class="mx-auto card-body" style="height:380px">
          <v-card-text>
            <v-row dense>
              <v-col cols="12" class="title blue--text"
                >Score Leaderboard</v-col
              >
            </v-row>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <leader-board
              :agentCoursesData="agent.courses"
              :agent="agent.id"
              :agentName="agent.name"
              :tabSelected="scoreTab"
              class="ml-2"
            />
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12">
        <v-card class="mx-auto card-body">
          <v-card-text>
            <v-row dense>
              <v-col cols="10" class="title blue--text"
                >Experience Timeline</v-col
              >
              <v-col cols="2" class="d-flex title blue--text justify-end"
                ><v-select
                  :items="timeOptions"
                  item-text="name"
                  item-value="name"
                  v-model="timeOption"
                  :label="timelineSelected"
                  @change="onTimeLine"
                ></v-select
              ></v-col>
            </v-row>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <timeline-line-chart
              :agentCoursesData="agent.courses"
              :agent="agent.id"
              :agentName="agent.name"
              :selectedOption="timeOption"
            />
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <v-row dense> </v-row>
    <v-row dense>
      <v-col cols="12">
        <data-log
          style="width:100%"
          :headers="headers"
          :logData="tableData"
          :title="tableTitle"
          :isLoading="loading"
          :csvFilename="csvFilename"
          :itemsPerPage="12"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import PieChart from '@/components/PieChart.vue'
import BubbleChart from '@/components/BubbleChart.vue'
import InteractionTimeBubbleChart from '@/components/InteractionTimeBubbleChart.vue'
import InteractionScoreBubbleChart from '@/components/InteractionScoreBubbleChart.vue'
import TimelineLineChart from '@/components/TimelineLineChart.vue'
import LeaderBoard from '@/components/LeaderBoard.vue'
import AllCoursesOverview from '@/components/AllCoursesOverview.vue'
import DataLog from '@/components/DataLog.vue'
import moment from 'moment'
import _ from 'lodash'
import {
  getDuration,
  Multiset,
  roundToTwo,
  getRandomColorFromList,
  interactionTitle,
  interactionTableHeader,
  interactionDetailTableHeader,
  TOTAL_ITEMS,
  pieChartStyle,
  ellipsisLongText,
  getDateOptionsFromInteractions
} from '../Constants'

export default {
  props: {
    agent: {
      type: Object,
      required: true
    }
  },
  components: {
    AllCoursesOverview,
    LeaderBoard,
    PieChart,
    TimelineLineChart,
    DataLog
  },
  data() {
    return {
      selectItems: null,
      selected: '',
      dataArr: [],
      launchesData: {},
      launchesOptions: {},
      interactionOptions: {},
      interactionData: {},
      scoreData: {},
      scoreOptions: {},
      allCoursesTimeData: null,
      allCoursesScoreData: null,
      headers: interactionDetailTableHeader,
      tableData: [],
      tableTitle: interactionTitle,
      csvFilename: 'download',
      loading: false,
      scoreTab: 0,
      timeTab: 1,
      timeOptions: ['all'],
      timeOption: {},
      timelineSelected: ''
    }
  },
  computed: {
    myStyles() {
      return pieChartStyle
    }
  },
  mounted() {
    this.setData()
    this.fillLaunchesData()
    this.fillInteractionsData()
    this.fillScoreData()
  },
  created() {
    this.selectItems = Object.assign([], this.agent.courses)
    this.selectItems.splice(0, 0, { id: -1, name: 'All' })
    this.selected = `Viewing: ${this.selectItems[0].name}`
  },
  methods: {
    onTimeLine(value) {
      this.timeOption = _.find(this.timeOptions, {
        name: value
      })
    },
    onCourseChange(value) {
      // all was selected
      if (value === -1) {
        if (this.selected === 'Viewing: All') {
          this.selected = `Viewing: All`
        } else {
          this.allCourses = true
          this.selected = `Loading ... All`
          this.$router.replace({ path: `/agent/${this.agentId}` })
        }
      } else {
        const course = _.find(this.selectItems, { id: value })
        this.selected = `Loading ... ${course.name}`
        this.$router.replace({
          path: `/courses/${value}?agentId=${
            this.agent.id
          }&agentName=${encodeURIComponent(this.agent.name)}`
        })
      }
    },
    setData() {
      this.tableData = []
      this.dataArr = []
      this.allCoursesTimeData = []
      this.loading = true
      let interactions = []
      const agentCoursesData = Object.assign([], this.agent.courses)
      agentCoursesData.forEach(element => {
        let courseId = element.id
        this.dataArr.push({
          id: element.id,
          name: element.name,
          attempts: element.attempts,
          interactions: element.interactions.length,
          failed: element.fail,
          passed: element.pass
        })

        interactions.push.apply(interactions, element.interactions)

        element.interactions.forEach(e => {
          if (e.duration != null && e.duration !== undefined) {
            e.duration = getDuration(e.duration)
          }
          e.courseId = courseId
          this.tableData.push(e)
        })
      })

      this.timeOptions = getDateOptionsFromInteractions(interactions)
      this.onTimeLine('all')

      this.loading = false
    },
    fillLaunchesData() {
      let launData = []
      let launLabels = []
      let backgroundColor = []

      this.dataArr.forEach(element => {
        launData.push(element.attempts)
        launLabels.push(element.name)
        backgroundColor.push(getRandomColorFromList(backgroundColor))
      })

      this.launchesOptions = {
        layout: {
          padding: {
            //bottom: 5, //set that fits the best
            top: 15
          }
        },
        hover: {
          onHover: function(e) {
            e.target.style.cursor = 'pointer'
          }
        },
        onClick: this.onClickLaunchCourse,
        legend: {
          display: false
        },
        tooltips: {
          callbacks: {
            title: function(tooltipItem, data) {
              return ellipsisLongText(
                data['labels'][tooltipItem[0]['index']],
                31
              )
            },
            label: function(tooltipItem, data) {
              const launches =
                data['datasets'][0]['metadata'][tooltipItem['index']]
              let toolTip = new Array()
              if (launches !== undefined && launches != null) {
                toolTip.push(`Launches: ${launches.attempts}`)
              }
              return toolTip
            }
          },
          backgroundColor: '#FFF',
          titleFontSize: 10,
          titleFontColor: '#000',
          bodyFontColor: '#000',
          bodyFontSize: 12,
          displayColors: false,
          borderWidth: 0.2,
          borderColor: '#000',
          yAlign: 'bottom'
        },
        responsive: true,
        maintainAspectRatio: false,
        cutoutPercentage: 30,
        animation: {
          animateRotate: true,
          animateScale: true
        }
      }

      this.launchesData = {
        labels: launLabels,
        datasets: [
          {
            metadata: this.dataArr,
            backgroundColor: backgroundColor,
            data: launData
          }
        ]
      }
    },
    onClickLaunchCourse(event, array) {
      const tooltipEl = document.getElementById('launch-chartjs-tooltip')
      if (tooltipEl) {
        tooltipEl.remove()
      }
      const index = array[0]._index
      const courseId =
        array[0]._chart.tooltip._data.datasets[0].metadata[index].id

      this.$router.push({ path: `/courses/${courseId}` })
    },
    fillInteractionsData() {
      let intData = []
      let intLabels = []
      let backgroundColor = []

      this.dataArr.forEach(element => {
        intData.push(element.interactions)
        intLabels.push(element.name)
        backgroundColor.push(getRandomColorFromList(backgroundColor))
      })

      this.interactionOptions = {
        layout: {
          padding: {
            //bottom: 5, //set that fits the best
            top: 15
          }
        },
        hover: {
          onHover: function(e) {
            e.target.style.cursor = 'pointer'
          }
        },
        onClick: this.onClickLaunchCourse,
        legend: {
          display: false
        },
        tooltips: {
          position: 'nearest',
          callbacks: {
            title: function(tooltipItem, data) {
              return ellipsisLongText(
                data['labels'][tooltipItem[0]['index']],
                31
              )
            },
            label: function(tooltipItem, data) {
              const interaction =
                data['datasets'][0]['metadata'][tooltipItem['index']]
              let toolTip = new Array()
              if (interaction !== undefined && interaction != null) {
                toolTip.push(`Interactions: ${interaction.interactions}`)
              }
              return toolTip
            }
          },
          backgroundColor: '#FFF',
          titleFontSize: 10,
          titleFontColor: '#000',
          bodyFontColor: '#000',
          bodyFontSize: 12,
          displayColors: false,
          borderWidth: 0.2,
          borderColor: '#000',
          yAlign: 'bottom'
        },
        responsive: true,
        maintainAspectRatio: false,
        cutoutPercentage: 30,
        animation: {
          animateRotate: true,
          animateScale: true
        }
      }

      this.interactionData = {
        labels: intLabels,
        datasets: [
          {
            metadata: this.dataArr,
            backgroundColor: backgroundColor,
            data: intData
          }
        ]
      }
    },
    fillScoreData() {
      let scoreLabels = ['Passed', 'Failed']
      let backgroundColor = ['#7ed321', '#f5a623']

      let failed = 0
      let passed = 0

      this.dataArr.forEach(element => {
        if (element.failed !== 0) {
          failed++
        }

        if (element.passed !== 0) {
          passed++
        }
      })

      this.scoreOptions = {
        layout: {
          padding: {
            //bottom: 5, //set that fits the best
            top: 15
          }
        },
        hover: {
          onHover: function(e) {
            e.target.style.cursor = 'pointer'
          }
        },
        onClick: this.onClickScore,
        legend: {
          display: false
        },
        tooltips: {
          position: 'nearest',
          callbacks: {
            title: function(tooltipItem, data) {
              return ellipsisLongText(
                data['labels'][tooltipItem[0]['index']],
                31
              )
            },
            label: function(tooltipItem, data) {
              const scoreData =
                data['datasets'][0]['data'][tooltipItem['index']]
              let toolTip = new Array()
              if (scoreData !== undefined && scoreData != null) {
                toolTip.push(`Count: ${scoreData}`)
              }
              return toolTip
            }
          },
          backgroundColor: '#FFF',
          titleFontSize: 10,
          titleFontColor: '#000',
          bodyFontColor: '#000',
          bodyFontSize: 12,
          displayColors: false,
          borderWidth: 0.2,
          borderColor: '#000',
          yAlign: 'bottom'
        },
        responsive: true,
        maintainAspectRatio: false,
        cutoutPercentage: 30,
        animation: {
          animateRotate: true,
          animateScale: true
        }
      }

      this.scoreData = {
        labels: scoreLabels,
        datasets: [
          {
            metadata: this.dataArr,
            backgroundColor: backgroundColor,
            data: [passed, failed]
          }
        ]
      }
    },
    onClickScore(event, array) {}
  }
}
</script>

<style>
.chart-container {
  position: relative;
  margin: auto;
  height: 80vh;
}
</style>
